module.exports = __webpack_public_path__ + "static/media/student-end-season-cup.c8ad453f.png";